import script from "/app/pages/Settings/edit_registered_product.vue?type=script";
import "/app/pages/Settings/edit_registered_product.vue?type=style";
import { render } from "/app/pages/Settings/edit_registered_product.vue?type=template";
script.render = render;
export default script;
